exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.embedDoc ._2LpwQ___Wrapper__cls1 {\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n}\n", ""]);

// exports
